var get_next = function (k, value) {
  var i = k - 1;
  while (value[i - 1] >= value[i]) i--;

  // all in reverse order
  if (i < 1) return false;

  var j = k;
  while (value[j - 1] <= value[i - 1]) j--;

  swap(i - 1, j - 1, value);

  i++;
  j = k;

  while (i < j) {
    swap(i - 1, j - 1, value);
    i++;
    j--;
  }

  return true;
};

var swap = function (a, b, value) {
  var temp = value[a];
  value[a] = value[b];
  value[b] = temp;
};

var put_next = function (pArray, k, value) {
  var tempArray = new Array();
  for (var i = 0; i < k; i++) tempArray.push(value[i]);

  pArray.push(tempArray);

  return pArray;
};

export function permutation(number, select) {
  // check input
  if (isNaN(number) || number <= 0 || isNaN(select) || select <= 0 || select > number) {
    return;
  }

  var permutationArray = new Array();
  var value = new Array();

  var a = new Array();
  for (var i = 0; i < select; i++) a[i] = i + 1;

  // The while (true) has a break in the middle of the block and is trending "i" downward - we're good.
  //eslint-disable-next-line no-constant-condition
  while (true) {
    for (var n = 0; n < select; n++) value[n] = a[n];

    // for this combination, list permutations in lexicographical order
    permutationArray = put_next(permutationArray, select, value);
    while (get_next(select, value)) permutationArray = put_next(permutationArray, select, value);

    // generate next combination in lexicographical order
    i = select - 1; // start at last item

    // find next item to increment
    while (a[i] === number - select + i + 1) --i;

    if (i < 0) break; // all done
    ++a[i];

    // do next combination
    for (var j = i + 1; j < select; j++) {
      a[j] = a[i] + j - i;
    }
  }

  return permutationArray;
}
